export default __webpack_public_path__ + "static/media/gls-it.5fc3e190.svg";